export default function LogoMark({ size = 40, className = "" }) {
  return (
    <img
      src="/logo.png"
      width={size}
      height={size}
      alt="HOFA — Hope For All Organizations logo"
      className={`shrink-0 rounded-full ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
